import common from '@/sui/data/sheets/convert/common'

import fields from '@/sui/data/sheets/edit/fields'

const diaInfections = (function () {
  const all = [
    { field: fields.infection },
    { field: fields.origin, cfield: 'bactOrigin' },
    { field: fields.date, special: 'date' },
    { field: fields.antibio }
  ]

  const v2 = [
    { field: fields.diagDate, special: 'date' },
    { field: fields.covidStatus }
  ]

  return {
    v1: [...all, common.specialMicroOrgs.noVirus.v1],
    v2: [...all, common.specialMicroOrgs.noVirus.v1, ...v2],
    v3: [...all, common.specialMicroOrgs.noVirus.v2, ...v2],
    v4: [...all, common.specialMicroOrgs.noVirus.v3, ...v2]
  }
})()

const diaLock = {
  v1: function (prefix) {
    return [
      { field: fields.heparine, cfield: `${prefix}heparine` },
      { field: fields.citrate, cfield: `${prefix}citrate` },
      { field: fields.antibio, cfield: `${prefix}antibio` },
      { field: fields.serumPhy, cfield: `${prefix}serumPhy` },
      { field: fields.taurine, cfield: `${prefix}taurine` },
      { field: fields.alcohol, cfield: `${prefix}alcohol` },
      { field: fields.other, cfield: `${prefix}other` },
      { field: fields.cap, cfield: `${prefix}cap` }
    ]
  },

  v2: function (prefix) {
    return [
      { field: fields.lock, cfield: `${prefix}Lock` },
      { field: fields.cap, cfield: `${prefix}cap` }
    ]
  }
}

const diaInfCatheters = (function () {
  const all = [
    { field: fields.firstUse, special: 'date' },
    { field: fields.uses, special: 'numeric' },
    { field: fields.incidents, special: 'numeric' },
    { field: fields.unrelatedManip, special: 'numeric' },
    { field: fields.ablated },
    { field: fields.ablation, special: 'date' },
    { field: fields.useEnded },
    { field: fields.useEnding, special: 'date' },
    { field: fields.installReason },
    { field: fields.tunneled },
    { field: fields.installSite },
    { field: fields.siteChanges },
    { field: fields.antibiopr }
  ]

  const v1 = [
    { field: fields.accessSite },
    { field: fields.installLock, object: diaLock.v1('install') },
    { field: fields.disconnectLock, object: diaLock.v1('disconnect') }
  ]

  const v2 = [
    common.addV2(fields.accessSite),
    { field: fields.installLock, object: diaLock.v2('install') },
    { field: fields.disconnectLock, object: diaLock.v2('disconnect') }
  ]

  const infections = (v) => { return { field: fields.infections, array: diaInfections[v] } }

  return {
    v1: [...v1, ...all, infections('v1')],
    v2: [...v2, ...all, infections('v2')],
    v3: [...v2, ...all, infections('v3')],
    v4: [...v2, ...all, infections('v4')]
  }
})()

const sheet = (function () {
  const all = [
    { field: fields.sheetNumber, special: 'numeric' },
    { field: fields.uf },
    { field: fields.birthdate, special: 'date' },
    { field: fields.sex },
    { field: fields.firstSubstn, special: 'date' },
    { field: fields.hemodiafiltr },
    { field: fields.entrydate, special: 'date' },
    { field: fields.treatedDiab },
    { field: fields.immuno },
    { field: fields.hygiene },
    { field: fields.previousInfect },
    { field: fields.previousBact },
    { field: fields.toxico },
    { field: fields.vih },
    { field: fields.vhc },
    { field: fields.height, special: 'numeric' },
    { field: fields.weight, special: 'numeric' },
    { field: fields.ferritinaemia, special: 'numeric' },
    { field: fields.saturation, special: 'numeric' },
    { field: fields.hemoglobin, special: 'numeric' },
    { field: fields.albumin, special: 'numeric' },
    { field: fields.creatinine, special: 'numeric' },
    { field: fields.dialNumber, special: 'numeric' },
    { field: fields.cardioVascPb },
    { field: fields.surgery },
    { field: fields.transfusions, special: 'numeric' },
    { field: fields.exit, special: 'date' },
    { field: fields.exitReason }
  ]

  const v1 = [
    { field: fields.unitType, special: 'unitType' },
    { field: fields.catheterArray, array: diaInfCatheters.v1 },
    { field: fields.bactArray, array: common.bacteremia.v1 }
  ]
  const v2 = [
    { field: fields.unitType, special: 'unitType' },
    { field: fields.catheterArray, array: diaInfCatheters.v2 },
    { field: fields.bactArray, array: common.bacteremia.v2 }
  ]
  const v3 = [
    { field: fields.unitType, special: 'unitType' },
    { field: fields.catheterArray, array: diaInfCatheters.v2 },
    { field: fields.bactArray, array: common.bacteremia.v3 },
    { field: fields.covidStatus }
  ]
  const v4 = [
    { field: fields.unitType, special: 'unitType' },
    { field: fields.catheterArray, array: diaInfCatheters.v3 },
    { field: fields.bactArray, array: common.bacteremia.v4 },
    { field: fields.covidStatus }
  ]
  const v5 = [
    { field: fields.unitType, special: 'unitType_v2' },
    { field: fields.catheterArray, array: diaInfCatheters.v3 },
    { field: fields.bactArray, array: common.bacteremia.v4 },
    { field: fields.covidStatus }
  ]
  const v6 = [
    { field: fields.unitType, special: 'unitType_v2' },
    { field: fields.catheterArray, array: diaInfCatheters.v4 },
    { field: fields.bactArray, array: common.bacteremia.v6 },
    { field: fields.covidStatus }
  ]

  return {
    '2019': [...all, ...v1],
    '2020': [...all, ...v2],
    '2021': [...all, ...v3],
    '2022': [...all, ...v3],
    '2023': [...all, ...v4],
    '2024': [...all, ...v5],
    '2025': [...all, ...v6],
    '2026': [...all, ...v6]
  }
})()

export default sheet
